import { Locale, K } from "../constants";

const locale: Locale = {
  [K.YESTERDAY]: "Yesterday",
  [K.TODAY]: "Today",
  [K.FUTURE_AFTER]: "After {{time}}",
  [K.FORMAT_SHORT]: "MMM D ah:mm",
  [K.FORMAT_SHORT_DAY]: "MMM D HH:mm",
  [K.MONTHS]: "Months",
  [K.HOURS]: "Hours",
  [K.SECONDS]: "Seconds",
  [K.MILL_SECONDS]: "Millseconds",
  [K.DAYS]: "Days",
  [K.MINUTES]: "Minutes",
  [K.TEN_HOURS_TEN_MINUTES_TEST]: "0.2 Seconds",
  [K.OO_TWO_ONE_SECONDS]: "0.021 Seconds",
  [K.ONE_TWO_SECONDS]: "1.2 秒",
};

export default locale;
